import NiceModal from '@ebay/nice-modal-react';

import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import Button from 'components/field/Button';
import ManageWidgetsModal from 'components/global/ManageWidgetsModal';
import { Container } from 'components/global/styled/WidgetsContainer.styled';

import { analysisChartsConfigRaw, chartsConfig } from 'pages/Analysis/analysisWidgetsConfig';
import { dashboardChartsConfigRaw } from 'pages/Dashboard/dashboardConfig';
import { homePageChartsConfigRaw } from 'pages/Home/RecurringPage/homePageChartsConfig';

import PATHS from 'utils/paths';

import { faObjectsColumn } from '@fortawesome/pro-solid-svg-icons';

import Card from './Card';
import NoRecordsFound from './NoRecordsFound';

// By default all widgets are visible.
// That is why we only take data from local storage and check if all widgets are not visible.
const WidgetPageContainer = ({ children }) => {
	const { pathname } = useLocation();
	const [noVisibleWidgets, setNoVisibleWidgets] = useState(
		JSON.parse(localStorage.getItem(`${pathname}_new`)) &&
			JSON.parse(localStorage.getItem(`${pathname}_new`)).every((widget) => !widget.isVisible)
	);

	const updateWidgetVisibility = () => {
		setNoVisibleWidgets(
			JSON.parse(localStorage.getItem(`${pathname}_new`)) &&
				JSON.parse(localStorage.getItem(`${pathname}_new`)).every((widget) => !widget.isVisible)
		);
	};

	useEffect(() => {
		window.addEventListener('updateWidgetVisibility', updateWidgetVisibility);

		return () => {
			window.removeEventListener('updateWidgetVisibility', updateWidgetVisibility);
		};
	}, []);

	let data;
	if (pathname.startsWith(PATHS.ANALYSIS)) {
		data = chartsConfig(analysisChartsConfigRaw);
	}
	if (pathname.startsWith(PATHS.DASHBOARD)) {
		data = chartsConfig(dashboardChartsConfigRaw);
	}
	if (pathname.startsWith(PATHS.HOME)) {
		data = chartsConfig(homePageChartsConfigRaw);
	}

	return noVisibleWidgets ? (
		<Container>
			<Card fullHeight fullWidth>
				<NoRecordsFound
					subTitle={'noRecordsFoundSubtitleManageWighets'}
					actionButton={
						<Button
							icon={faObjectsColumn}
							label={'manageWidgets.buttonLabel'}
							variant="blue"
							onClick={() =>
								NiceModal.show(ManageWidgetsModal, {
									data
								})
							}
						/>
					}
				/>
			</Card>
		</Container>
	) : (
		<Container>{children}</Container>
	);
};

export default WidgetPageContainer;
